<template>
  <div class="app-brand">
    <router-link :to="{ name: 'Home' }" v-if="user">
      <img class="app-brand__logo" :src="oemInfo.publicLogo" v-if="primary">
      <img class="app-brand__logo" :src="oemInfo.privateLogo" v-else>
    </router-link>
    <router-link :to="{ name: 'Login' }" v-else-if="!user">
      <img class="app-brand__logo" :src="oemInfo.publicLogo" v-if="primary">
      <img class="app-brand__logo" :src="oemInfo.privateLogo" v-else>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'AppBrand',
  props: {
    primary: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    user () {
      return this.$store.state.account.user
    },

    oemInfo () {
      return this.$store.state.share.oemInfo
    }
  }
}
</script>

<style lang="scss">
.app-brand {
  > a {
    display: inline-block;
  }

  img {
    width: auto;
    height: 26px;
  }
}
</style>
